/* KFH bundle guide: one texture chip row drives the length figure (dots, the picked length labelled), the
   landmark list beside it, and the closure tiles (only that texture's closures, with their real From price).
   Data comes from kfh-guide.liquid. */
(() => {
  const SHAPE = (t) => Number(t.shape) || 0;
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-kfh-guide-data]').textContent);
    const s = data.strings;
    const $ = (sel) => root.querySelector(sel);
    const $$ = (sel) => [...root.querySelectorAll(sel)];
    const fill = (str, map) => Object.entries(map).reduce((a, [k, v]) => a.split(`[${k}]`).join(v), str || '');
    const state = { tex: Math.min(Math.max(data.startTexture, 0), data.textures.length - 1), len: 18 };
    const tex = () => data.textures[state.tex];

    const pickLen = (n) => { state.len = n; render(); };
    const renderBody = () => {
      const t = tex();
      $$('[data-kfh-guide-tab]').forEach((b) => b.setAttribute('aria-selected', String(Number(b.dataset.kfhGuideTab) === state.tex)));
      const lens = t.lengths.length ? t.lengths : Object.keys(data.landmarks).map(Number).filter(Boolean);
      if (!lens.includes(state.len)) state.len = lens.includes(18) ? 18 : lens[0];
      // The list carries the labels; the figure shows dots and only the picked length's label.
      const list = $('[data-kfh-guide-lens]');
      list.replaceChildren(...lens.map((n) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'kfh-guide__len';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(n === state.len));
        b.innerHTML = `<b>${n} in</b><span>${data.landmarks[n] || ''}</span>`;
        b.addEventListener('click', () => pickLen(n));
        return b;
      }));
      const fig = $('[data-kfh-figure]');
      if (fig && window.KFH && window.KFH.drawFigure) {
        window.KFH.drawFigure(fig, {
          len: state.len,
          shape: SHAPE(t),
          compact: true,
          lengths: lens.map((n) => ({ n, label: data.landmarks[n] ? `${n} in · ${data.landmarks[n]}` : `${n} in` })),
          onPick: (m) => pickLen(m.n),
        });
      }
    };
    // Closure tiles: one per type, shown only when this texture has that closure.
    const renderClosures = () => {
      const t = tex();
      const by = Object.fromEntries(t.closures.map((c) => [c.kind, c]));
      let shown = 0;
      $$('[data-kfh-guide-kind]').forEach((li) => {
        const c = by[li.dataset.kfhGuideKind];
        li.hidden = !c;
        if (!c) return;
        shown += 1;
        li.querySelector('a').href = c.url;
        const img = li.querySelector('img');
        if (c.image) img.src = c.image;
        li.querySelector('[data-kfh-guide-from]').textContent = fill(s.from, { price: c.from });
      });
      const none = $('[data-kfh-guide-none]');
      if (none) { none.hidden = shown > 0; none.textContent = fill(s.noClosure, { texture: t.line || t.name }); }
      const label = $('[data-kfh-guide-cl-tex]');
      if (label) label.textContent = `· ${t.line || t.name}`;
    };
    const render = () => { renderBody(); renderClosures(); };

    $$('[data-kfh-guide-tab]').forEach((b) => b.addEventListener('click', () => { state.tex = Number(b.dataset.kfhGuideTab); render(); }));
    render();
  };

  const boot = () => document.querySelectorAll('[data-kfh-guide]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
